import React, { Component } from 'react';

import Question from './Question';
import Answer from './Answer';
import ResultLoader from './ResultLoader';
import Error from './Error';

class Router extends Component {
  constructor(props) {
    super(props);

    // Intentionally ignore prop updates: this component will only ever render
    // a single view during its lifecycle
    this.state = {
      currentView: this.props.currentView
    };
  }

  render() {
    switch (this.state.currentView) {
      case 'question':
        return <Question {...this.props} />;
      case 'answer':
        return <Answer {...this.props} />;
      case 'result':
        return <ResultLoader {...this.props} />;
      case 'error':
        return <Error {...this.props} />;
      default:
        return <Question {...this.props} />;
    }
  }
}

export default Router;
